// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"AnnouncementsPage_layoutWrapperMain__1OnTv","addNewBtn":"AnnouncementsPage_addNewBtn__1HKpu"};